import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import CheckIcon from '~/components/icons/check-small';

const StyledCheckIcon = styled(CheckIcon).attrs({
  color: '#CB2233',
})`
  flex-shrink: 0;
  margin-right: 10px;
`;

const IconContainer = styled.div`
  display: flex;
  margin-right: 8px;
  width: 20px;
  height: 20px;
  align-items: center;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: ${({ theme }) => theme.darkFont};
`;

const Feature = ({ text }) => (
  <Item>
    <IconContainer>
      <StyledCheckIcon size={ 12 } />
    </IconContainer>
    { text }
  </Item>
);

Feature.propTypes = {
  text: PropTypes.string,
};

export default Feature;
